import { Modal } from "antd";
import React, { useEffect, useState } from "react";
import { CompassOutlined } from "@ant-design/icons";
import FilterButton from "../../piece/FilterButton";
import StateDropdown from "../../contact/StateDropdown";

export default (props) => {
    const [visible, setVisible] = useState(false)
    const [defaultValue, setDefaultValue] = useState(null)
    const [value, setValue] = useState(null)
    useEffect(() => {
        setDefaultValue(props.defaultValue)
    }, [props])

    const onChangeCascade = (value) => {
        if (!value)
            return
        setValue(value[0])
    }

    return (
        <>
            <FilterButton
                onClick={() => {
                    setVisible(true)
                }}
            >
                <CompassOutlined /> State
            </FilterButton>
            <Modal
                title='State Filter'
                visible={visible}
                open={visible}
                onOk={() => {
                    if (props.onChange) {
                        props.onChange({
                            stateFilter: {
                                text: 'State: ',
                                value: value
                            },
                        })
                    }
                    setVisible(false)
                }}
                onCancel={() => {
                    setVisible(false)
                }}
                destroyOnClose={true}
            >
                <StateDropdown
                    onChange={onChangeCascade}
                    allowClear={true}
                />
            </Modal>
        </>
    )
}